const avatars = [
  'https://firebasestorage.googleapis.com/v0/b/forty-spacetacos.appspot.com/o/cat1.png?alt=media&token=a240ff37-b15b-48c2-8fce-28a6475da77e',
  'https://firebasestorage.googleapis.com/v0/b/forty-spacetacos.appspot.com/o/cat2.png?alt=media&token=9cb8e358-d9a5-45c8-92f7-7316a8a0ca51',
  'https://firebasestorage.googleapis.com/v0/b/forty-spacetacos.appspot.com/o/cat3.png?alt=media&token=c5b5121f-cd24-435b-9802-1a7bf03945a3',
  'https://firebasestorage.googleapis.com/v0/b/forty-spacetacos.appspot.com/o/moon.png?alt=media&token=b2a98170-8d2e-4ae8-ae9b-774e3ced09f7',
  'https://firebasestorage.googleapis.com/v0/b/forty-spacetacos.appspot.com/o/spacecat.png?alt=media&token=86389eaa-7bf1-4864-8ab5-96121a51d3eb'
]

export const getAnyAvatar = () => avatars[Math.floor(Math.random() * avatars.length)]
